<div (click)="openFilePicker()" class="h-100 uploadHover">
  <div (dragenter)="isDragOverEmitter.emit(true)"
       (dragleave)="isDragOverEmitter.emit(false) "
       (dragover)="dragOverHandler($event)"
       (drop)="isDragOverEmitter.emit(false); dropHandler($event);"
       class="w-100 h-100 d-flex align-items-center justify-content-center flex-column"
       id="dropzone">
    <a class="bigRoundButton mb-3">
      <sb-icon icon="plus"></sb-icon>
    </a>
    <p class="text-center m-0">{{'lang.globals.dragDropFiles' | translate}}</p>
  </div>
</div>

<input #filePicker (change)="filePicked()" multiple style="display:none;" type="file">
